module.exports = __webpack_public_path__ + "img/stop_btn.40854fcf.png";